module.exports = __webpack_public_path__ + "static/media/aterts.abe53773.svg";